import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/blueTxt.png';
import _imports_1 from '@/assets/images/purpleTxt.png';
const _withScopeId = n => (_pushScopeId("data-v-5e5323a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "main-content"
};
import { ref } from 'vue';
// import Header from '@/components/Header'
// import PageFooter from '@/components/PageFooter'
// 海报抄袭数据集
import PlagiarizedPoster from '@/components/PlagiarizedPoster';
// 现代海报数据集
import ModernPoster from '@/components/ModernPoster';
// import ChineseStyleElementDatabase from '@/components/ChineseStyleElementDatabase'

export default {
  __name: 'Resources',
  setup(__props) {
    const index = ref(0);
    const handleCarousel = i => {
      index.value = i;
    };
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_carousel, {
        arrow: "always",
        trigger: "click",
        autoplay: false,
        "indicator-position": "none",
        onChange: handleCarousel
      }, {
        default: _withCtx(() => [_createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(_unref(PlagiarizedPoster), null, null, 512), [[_vShow, index.value === 0]]), _withDirectives(_createVNode(_unref(ModernPoster), null, null, 512), [[_vShow, index.value === 1]])])], 64);
    };
  }
};